import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { AddLoadComponent } from './add-load.component';
import { LoadListElementComponent } from './components/load-list-element/load-list-element.component';
import { LoadDimensionsComponent } from './components/load-dimensions/load-dimensions.component';
import { LoadStackingComponent } from './components/load-stacking/load-stacking.component';
import { LoadRotateComponent } from './components/load-rotate/load-rotate.component';
import { LoadPreviewComponent } from './components/load-preview/load-preview.component';
import { LoadChooserComponent } from './components/load-chooser/load-chooser.component';
import { LoadLoadingPlacesComponent } from './components/load-loading-places/load-loading-places.component';
import { LoadGravityOfCenterComponent } from './components/load-gravity-of-center/load-gravity-of-center.component';
import { LoadInterlayersComponent } from './components/load-interlayers/load-interlayers.component';
import { LoadPalletArrangementComponent } from './components/load-pallet-arrangement/load-pallet-arrangement.component';

@NgModule({
  declarations: [
    LoadPreviewComponent,
    AddLoadComponent,
    LoadListElementComponent,
    LoadDimensionsComponent,
    LoadStackingComponent,
    LoadRotateComponent,
    LoadChooserComponent,
    LoadLoadingPlacesComponent,
    LoadGravityOfCenterComponent,
    LoadInterlayersComponent,
    LoadPalletArrangementComponent,
  ],
  imports: [CommonModule, SharedModule],
  exports: [
    AddLoadComponent,
    LoadPreviewComponent,
    LoadListElementComponent,
    LoadDimensionsComponent,
    LoadStackingComponent,
    LoadRotateComponent,
    LoadChooserComponent,
    LoadGravityOfCenterComponent,
    LoadInterlayersComponent,
    LoadPalletArrangementComponent,
  ],
})
export class AddLoadModule {}
